import { ActionTypes } from "../constants/action-types";

const initialState = {
  type: "",
  category: "",
  subcategory: "",
};

export const filterReducer = (state = initialState, {type, payload}) => {

  switch (type) {
    case ActionTypes.SELECTED_FILTERS:
      return {
        ...state,
        ...payload
      }
  
    default: return state
  }
}